module.exports = __webpack_public_path__ + "media/message_sent2.62acf35b.wav";